module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "github-lawn"
  }, _vm._l((_vm.github), function(week) {
    return _c('ul', _vm._l((week), function(d) {
      return (d.num != null) ? _c('li', {
        class: _vm.calc(d.num)
      }, [_c('div', {
        staticClass: "tip"
      }, [_c('span', [_vm._v(_vm._s(d.num) + " " + _vm._s(_vm.unit) + "on " + _vm._s(d.date))])])]) : _vm._e()
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-411e271f","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GithubLawn.vue
// module id = 118
// module chunks = 0